import {
  getInvoice, getAnalytics, getRoadMap,
  getTimePerformance, getSavings, getTotalSpendingYTD,
  getTodolist, updateIsReadTodo, getNotifications,
  getNotificationsAll, updateIsReadNotif, getTodolistPagination, getCredit, getRoadMapCountry
} from '@/api/dashboard.api'

export const FETCH_CREDIT = 'FETCH_CREDIT'
export const FETCH_CREDIT_LOADING = 'FETCH_CREDIT_LOADING'
export const FETCH_CREDIT_DONE = 'FETCH_CREDIT_DONE'
export const FETCH_CREDIT_ERROR = 'FETCH_CREDIT_ERROR'

export const FETCH_ANALYTICS = 'FETCH_ANALYTICS'
export const FETCH_ANALYTICS_LOADING = 'FETCH_ANALYTICS_LOADING'
export const FETCH_ANALYTICS_DONE = 'FETCH_ANALYTICS_DONE'
export const FETCH_ANALYTICS_ERROR = 'FETCH_ANALYTICS_ERROR'

export const FETCH_OVERDUE_INVOICE = 'FETCH_OVERDUE_INVOICE'
export const FETCH_OVERDUE_INVOICE_LOADING = 'FETCH_OVERDUE_INVOICE_LOADING'
export const FETCH_OVERDUE_INVOICE_DONE = 'FETCH_OVERDUE_INVOICE_DONE'
export const FETCH_OVERDUE_INVOICE_ERROR = 'FETCH_OVERDUE_INVOICE_ERROR'

export const FETCH_UPCOMING_INVOICE = 'FETCH_UPCOMING_INVOICE'
export const FETCH_UPCOMING_INVOICE_LOADING = 'FETCH_UPCOMING_INVOICE_LOADING'
export const FETCH_UPCOMING_INVOICE_DONE = 'FETCH_UPCOMING_INVOICE_DONE'
export const FETCH_UPCOMING_INVOICE_ERROR = 'FETCH_UPCOMING_INVOICE_ERROR'

export const FETCH_ROAD_MAP = 'FETCH_ROAD_MAP'
export const FETCH_ROAD_MAP_LOADING = 'FETCH_ROAD_MAP_LOADING'
export const FETCH_ROAD_MAP_DONE = 'FETCH_ROAD_MAP_DONE'
export const FETCH_ROAD_MAP_ERROR = 'FETCH_ROAD_MAP_ERROR'

export const FETCH_TIME_PERFORMANCE = 'FETCH_TIME_PERFORMANCE'
export const FETCH_TIME_PERFORMANCE_LOADING = 'FETCH_TIME_PERFORMANCE_LOADING'
export const FETCH_TIME_PERFORMANCE_DONE = 'FETCH_TIME_PERFORMANCE_DONE'
export const FETCH_TIME_PERFORMANCE_ERROR = 'FETCH_TIME_PERFORMANCE_ERROR'

export const FETCH_SAVINGS = 'FETCH_SAVINGS'
export const FETCH_SAVINGS_LOADING = 'FETCH_SAVINGS_LOADING'
export const FETCH_SAVINGS_DONE = 'FETCH_SAVINGS_DONE'
export const FETCH_SAVINGS_ERROR = 'FETCH_SAVINGS_ERROR'

export const FETCH_SPENDING_YTD = 'FETCH_SPENDING_YTD'
export const FETCH_SPENDING_YTD_LOADING = 'FETCH_SPENDING_YTD_LOADING'
export const FETCH_SPENDING_YTD_DONE = 'FETCH_SPENDING_YTD_DONE'
export const FETCH_SPENDING_YTD_ERROR = 'FETCH_SPENDING_YTD_ERROR'

export const FETCH_TODO = 'FETCH_TODO'
export const FETCH_TODO_LOADING = 'FETCH_TODO_LOADING'
export const FETCH_TODO_DONE = 'FETCH_TODO_DONE'
export const FETCH_TODO_ERROR = 'FETCH_TODO_ERROR'

export const FETCH_TODO_ALL = 'FETCH_TODO_ALL'
export const FETCH_TODO_ALL_LOADING = 'FETCH_TODO_ALL_LOADING'
export const FETCH_TODO_ALL_DONE = 'FETCH_TODO_ALL_DONE'
export const FETCH_TODO_ALL_ERROR = 'FETCH_TODO_ALL_ERROR'

export const UPDATE_ISREAD_TODO = 'UPDATE_ISREAD_TODO'
export const UPDATE_ISREAD_TODO_LOADING = 'UPDATE_ISREAD_TODO_LOADING'
export const UPDATE_ISREAD_TODO_DONE = 'UPDATE_ISREAD_TODO_DONE'
export const UPDATE_ISREAD_TODO_ERROR = 'UPDATE_ISREAD_TODO_ERROR'

export const FETCH_NOTIFICATION = 'FETCH_NOTIFICATION'
export const FETCH_NOTIFICATION_LOADING = 'FETCH_NOTIFICATION_LOADING'
export const FETCH_NOTIFICATION_DONE = 'FETCH_NOTIFICATION_DONE'
export const FETCH_NOTIFICATION_ERROR = 'FETCH_NOTIFICATION_ERROR'

export const FETCH_NOTIFICATION_ALL = 'FETCH_NOTIFICATION_ALL'
export const FETCH_NOTIFICATION_ALL_LOADING = 'FETCH_NOTIFICATION_ALL_LOADING'
export const FETCH_NOTIFICATION_ALL_DONE = 'FETCH_NOTIFICATION_ALL_DONE'
export const FETCH_NOTIFICATION_ALL_ERROR = 'FETCH_NOTIFICATION_ALL_ERROR'

export const UPDATE_ISREAD_NOTIF = 'UPDATE_ISREAD_NOTIF'
export const UPDATE_ISREAD_NOTIF_LOADING = 'UPDATE_ISREAD_NOTIF_LOADING'
export const UPDATE_ISREAD_NOTIF_DONE = 'UPDATE_ISREAD_NOTIF_DONE'
export const UPDATE_ISREAD_NOTIF_ERROR = 'UPDATE_ISREAD_NOTIF_ERROR'

export const GET_ROADMAP_COUNTRY = 'GET_ROADMAP_COUNTRY'
export const GET_ROADMAP_COUNTRY_LOADING = 'GET_ROADMAP_COUNTRY_LOADING'
export const GET_ROADMAP_COUNTRY_ERROR = 'GET_ROADMAP_COUNTRY_ERROR'
export const GET_ROADMAP_COUNTRY_DONE = 'GET_ROADMAP_COUNTRY_DONE'

export default {
  [FETCH_ANALYTICS] (context, {type, year}) {
    context.commit(FETCH_ANALYTICS_LOADING)
    return getAnalytics(type, year)
      .then((response) => {
        context.commit(FETCH_ANALYTICS_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ANALYTICS_ERROR, error)
      })
  },

  [FETCH_CREDIT] (context) {
    context.commit(FETCH_CREDIT_LOADING)
    return getCredit()
      .then((response) => {
        context.commit(FETCH_CREDIT_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_CREDIT_ERROR, error)
      })
  },

  [FETCH_OVERDUE_INVOICE] (context) {
    context.commit(FETCH_OVERDUE_INVOICE_LOADING)
    return getInvoice('overdue')
      .then((response) => {
        context.commit(FETCH_OVERDUE_INVOICE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_OVERDUE_INVOICE_ERROR, error)
      })
  },

  [FETCH_UPCOMING_INVOICE] (context) {
    context.commit(FETCH_UPCOMING_INVOICE_LOADING)
    return getInvoice('upcoming')
      .then((response) => {
        context.commit(FETCH_UPCOMING_INVOICE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_UPCOMING_INVOICE_ERROR, error)
      })
  },

  [FETCH_ROAD_MAP] (context) {
    context.commit(FETCH_ROAD_MAP_LOADING)
    return getRoadMap()
      .then((response) => {
        context.commit(FETCH_ROAD_MAP_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ROAD_MAP_ERROR, error)
      })
  },

  [FETCH_TIME_PERFORMANCE] (context) {
    context.commit(FETCH_TIME_PERFORMANCE_LOADING)
    return getTimePerformance()
      .then((response) => {
        context.commit(FETCH_TIME_PERFORMANCE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_TIME_PERFORMANCE_ERROR, error)
      })
  },

  [FETCH_SAVINGS] (context) {
    context.commit(FETCH_SAVINGS_LOADING)
    return getSavings()
      .then((response) => {
        context.commit(FETCH_SAVINGS_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SAVINGS_ERROR, error)
      })
  },

  [FETCH_SPENDING_YTD] (context) {
    context.commit(FETCH_SPENDING_YTD_LOADING)
    return getTotalSpendingYTD()
      .then((response) => {
        context.commit(FETCH_SPENDING_YTD_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SPENDING_YTD_ERROR, error)
      })
  },

  [FETCH_TODO] (context) {
    context.commit(FETCH_TODO_LOADING)
    return getTodolist()
      .then((response) => {
        context.commit(FETCH_TODO_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_TODO_ERROR, error)
      })
  },

  [FETCH_TODO_ALL] (context, { currentPage, perPage }) {
    context.commit(FETCH_TODO_ALL_LOADING)
    return getTodolistPagination(currentPage, perPage)
      .then((response) => {
        context.commit(FETCH_TODO_ALL_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_TODO_ALL_ERROR, error)
      })
  },

  [UPDATE_ISREAD_TODO] (context, payload) {
    context.commit(UPDATE_ISREAD_TODO_LOADING)
    return updateIsReadTodo(payload)
      .then((response) => {
        context.commit(UPDATE_ISREAD_TODO_DONE, response)
      })
      .catch((error) => {
        context.commit(UPDATE_ISREAD_TODO_ERROR, error)
      })
  },

  [FETCH_NOTIFICATION] (context) {
    context.commit(FETCH_NOTIFICATION_LOADING)
    return getNotifications()
      .then((response) => {
        context.commit(FETCH_NOTIFICATION_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_NOTIFICATION_ERROR, error)
      })
  },

  [FETCH_NOTIFICATION_ALL] (context, page) {
    context.commit(FETCH_NOTIFICATION_ALL_LOADING)
    return getNotificationsAll(page)
      .then((response) => {
        context.commit(FETCH_NOTIFICATION_ALL_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_NOTIFICATION_ALL_ERROR, error)
      })
  },

  [UPDATE_ISREAD_NOTIF] (context, payload) {
    context.commit(UPDATE_ISREAD_NOTIF_LOADING)
    return updateIsReadNotif(payload)
      .then((response) => {
        context.commit(UPDATE_ISREAD_NOTIF_DONE, response)
      })
      .catch((error) => {
        context.commit(UPDATE_ISREAD_NOTIF_ERROR, error)
      })
  },

  [GET_ROADMAP_COUNTRY] (context) {
    context.commit(GET_ROADMAP_COUNTRY_LOADING)
    return getRoadMapCountry()
      .then((response) => {
        context.commit(GET_ROADMAP_COUNTRY_DONE, response)
      })
      .catch((error) => {
        context.commit(GET_ROADMAP_COUNTRY_ERROR, error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js